import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

export const InfoIcon = props => {
  const tooltip = <Tooltip id="tooltip">{props.children}</Tooltip>;
  return (
    <OverlayTrigger placement="top" overlay={tooltip}>
      <span className="glyphicon glyphicon-info-sign poa-info-sign" />
    </OverlayTrigger>
  );
};



// WEBPACK FOOTER //
// ./src/components/base-components/Info-icon.js